import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import Footer from "../../helpers/Footer"

declare var root: any

var footer = document.getElementById("footer")

const Footeris = () => {

  return (
    <>
      <Footer ruby={true} />
    </>
  )
}

if (footer) {
  ReactDOM.render(<Footeris />, footer)
}
